<div class="flex flex-column h-full">
  <div class="flex justify-content-end mb-2">
    <app-prime-ng-export-table [primeNgList]="this"></app-prime-ng-export-table>
    <button
      pButton
      pRipple
      type="button"
      icon="pi pi-table"
      label="{{ 'FORM.SHOW-HIDE-COLUMNS' | translate }}"
      class="p-button-success me-3 position-relative"
      (click)="openColumnSidebar()"
    ></button>
  </div>
  <div class="flex-grow overflow-hidden h-full">
    <p-table
      [columns]="columns"
      [dataKey]="keys.primary_key"
      [value]="rows"
      [loading]="loading"
      [paginator]="true"
      [rows]="rowsPerPage"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      styleClass="p-datatable-gridlines"
      [(selection)]="selectedRows"
      [scrollable]="true"
      scrollHeight="flex"
      [resizableColumns]="true"
      [currentPageReportTemplate]="
        'GENERAL.SHOWING-X-TO-Y-OF-Z-ROWS'
          | translate
            : {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
              }
      "
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3rem" pFrozenColumn>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <ng-container *ngFor="let col of columns">
            <th
              [pSortableColumn]="col.sortable"
              pFrozenColumn
              [frozen]="col.frozen"
              pResizableColumn
              [pResizableColumnDisabled]="!col.resizable"
              [width]="col.width"
              [style.minWidth.px]="col.resizable ? 0 : col.width"
              *ngIf="col.visible"
            >
              <div class="flex align-items-center gap-2">
                {{ col.header | translate }}
                <p-sortIcon
                  *ngIf="col.sortable"
                  [field]="col.sortable"
                ></p-sortIcon>
                <p-columnFilter
                  *ngIf="col.filterable"
                  type="text"
                  [field]="col.sortable"
                  display="menu"
                ></p-columnFilter>
              </div>
            </th>
          </ng-container>
          <th
            style="min-width: 125px"
            [width]="125"
            alignFrozen="right"
            pFrozenColumn
          ></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <td pFrozenColumn>
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let col of columns">
            <td
              pFrozenColumn
              [frozen]="col.frozen"
              [width]="col.width"
              *ngIf="col.visible"
            >
              <div style="white-space: pre-line">
                {{ col.field | ngCellValue : row }}
              </div>
            </td>
          </ng-container>
          <td
            style="min-width: 125px"
            [width]="125"
            class="p-2"
            alignFrozen="right"
            pFrozenColumn
          >
            <div
              class="flex flex-grow-1 justify-content-center md:justify-content-end mt-2 md:mt-0 gap-2"
            >
              <button
                pButton
                pRipple
                icon="pi pi-eye"
                pTooltip="{{ 'FORM.SEE-CONTENT' | translate }}"
                [tooltipPosition]="'bottom'"
                (click)="handlePDF(row)"
                class="p-button-text p-button-raised p-button-success"
              ></button>
              <button
                pButton
                pRipple
                icon="pi pi-book"
                pTooltip="{{ 'CORE.SOLVE' | translate }}"
                [tooltipPosition]="'bottom'"
                (click)="onSolveDialog(row)"
                class="p-button-text p-button-raised"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">{{ "WIDGET.DT-EMPTY" | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar
  [(visible)]="isColumnToggleVisible"
  position="right"
  [baseZIndex]="10000"
  [style]="{ width: '100%', 'max-width': '20em' }"
>
  <app-prime-list-columns-toggle
    [(columns)]="columns"
  ></app-prime-list-columns-toggle>
</p-sidebar>

<p-dialog
  header="{{ 'MENU.REPORTS' | translate }}"
  [(visible)]="isPdfTableDialogVisible"
  [modal]="true"
  [style]="{ width: '95%', height: '95%' }"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{ height: '100%' }"
>
  <app-modal-table-pdf
    *ngIf="isPdfTableDialogVisible"
    [itemSelection]="itemSelected"
    [courseDetail]="courseDetail"
    [selectedDataColumns]="columns"
    [selectedDataTable]="rows"
  >
  </app-modal-table-pdf>
</p-dialog>

<p-sidebar
  [(visible)]="isVisibleResource"
  position="right"
  [baseZIndex]="10000"
  [style]="{ width: '100%', 'max-width': '60em' }"
>
  <ng-template pTemplate="header">
    <div class="w-full flex justify-content-between align-items-center">
      <h3>
        {{ "FORM.FORMULA" | translate }} |
        {{ " " + itemSelected.first_name + " " + itemSelected.last_name }}
      </h3>
      <a
        [href]="pdfUrl"
        target="_blank"
        style="color: inherit; text-decoration: none"
        class="flex align-items-center mb-3"
      >
        <button
          pButton
          type="button"
          label="{{ 'GENERAL.SEE' | translate }} Recurso"
          icon="pi pi-file"
        ></button>
      </a>
    </div>
  </ng-template>
  <iframe
    [src]="pdfUrl"
    width="100%"
    *ngIf="itemSelected.ext === 'pdf' && isVisibleResource === true"
    height="100%"
    frameborder="0"
  >
  </iframe>

  <app-aws-image-viewer
    [completePath]="
      'ext/user/' +
      itemSelected.user_id +
      '/formula/resource.' +
      itemSelected.ext
    "
    *ngIf="itemSelected.ext !== 'pdf' && isVisibleResource === true"
  >
  </app-aws-image-viewer>
</p-sidebar>

<p-dialog
  header="{{ 'MENU.REPORTS' | translate }}"
  [(visible)]="solveDialogVisible"
  [modal]="true"
  [style]="{ width: '95%', height: '95%' }"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{ height: '100%' }"
>
  <ng-template pTemplate="header">
    <div class="w-full flex row align-items-center">
      <h3 class="col-4">
        {{ "FORM.FORMULA" | translate }} |
        {{ " " + itemSelected.first_name + " " + itemSelected.last_name }}
      </h3>
      <div class="col-4 text-end flex justify-content-center">
        <div class="flex flex-column gap-2 my-4">
          <label for="tags">{{ "FORM.REJECT" | translate }}</label>
          <p-selectButton
            [options]="sequentialOptions"
            id="squential-units"
            name="squential-units"
            optionLabel="label"
            optionValue="value"
            class="ng-dirty"
            [(ngModel)]="form.reject"
            required
          >
            <ng-template let-item pTemplate>
              {{ item.label | translate }}
            </ng-template>
          </p-selectButton>
        </div>
      </div>
      <div class="col-4 flex justify-content-end">
        <button
          pButton
          pRipple
          type="button"
          (click)="onSolveUser()"
          label="{{ 'ENV.SAVE' | translate }}"
          styleClass="p-button-success"
        ></button>
      </div>
    </div>
  </ng-template>

  <iframe
    [src]="pdfUrl"
    width="100%"
    *ngIf="itemSelected.ext === 'pdf' && solveDialogVisible === true"
    height="100%"
    frameborder="0"
  >
  </iframe>

  <app-aws-image-viewer
    [completePath]="
      'ext/user/' +
      itemSelected.user_id +
      '/formula/resource.' +
      itemSelected.ext
    "
    *ngIf="itemSelected.ext !== 'pdf' && solveDialogVisible === true"
  >
  </app-aws-image-viewer>

  <ng-template pTemplate="footer">
    <div class="w-full flex justify-content-between align-items-center">
      <a
        [href]="pdfUrl"
        target="_blank"
        style="color: inherit; text-decoration: none"
        class="flex align-items-center"
      >
        <button
          pButton
          type="button"
          label="{{ 'GENERAL.SEE' | translate }} Recurso"
          icon="pi pi-file"
        ></button>
      </a>
    </div>
  </ng-template>
</p-dialog>
